"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardTitle = exports.Card = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var ConfigProvider_1 = require("../ConfigProvider");
var utils_1 = require("../utils");
function Card(props) {
    var _a = props.type, type = _a === void 0 ? 'simple' : _a, children = props.children, title = props.title, _b = props.size, size = _b === void 0 ? 'default' : _b, className = props.className, style = props.style;
    var prefix = ConfigProvider_1.usePrefix('card');
    var typeCls = utils_1.concat(prefix, type);
    var sizeCls = utils_1.concat(prefix, size);
    return (react_1.default.createElement("div", { className: classnames_1.default(prefix, typeCls, sizeCls, className), style: style },
        renderTitle(title),
        react_1.default.createElement(CardContent, null, children)));
}
exports.Card = Card;
function renderTitle(title) {
    if (react_1.isValidElement(title))
        return title;
    return react_1.default.createElement(CardTitle, { title: title });
}
function CardTitle(_a) {
    var title = _a.title, _b = _a.bordered, bordered = _b === void 0 ? true : _b, extra = _a.extra, className = _a.className, style = _a.style;
    var prefix = ConfigProvider_1.usePrefix('card');
    if (title == null) {
        return null;
    }
    return (react_1.default.createElement("div", { className: classnames_1.default(utils_1.concat(prefix, 'title'), !bordered && utils_1.concat(prefix, 'title', 'no-border'), className), style: style },
        title,
        react_1.default.createElement("span", { className: utils_1.concat(prefix, 'title', 'extra') }, extra)));
}
exports.CardTitle = CardTitle;
function CardContent(_a) {
    var children = _a.children;
    var prefix = ConfigProvider_1.usePrefix('card');
    return (react_1.default.createElement("div", { className: utils_1.concat(prefix, 'content') }, children));
}
//# sourceMappingURL=index.js.map